module.exports = "<p>{{itemid}}   itemid</p>\r\n<p>{{item.url}}   item.url</p>\r\n<iframe  height=\"1100\" width=\"940\" src=\"{{cleanurl}}\"></iframe>\r\n"